"use client";

import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "@/config/firebaseApp";

/**
 * Si Firebase ya restauró la sesión, y de quién es.
 *
 * Reemplaza a `useAuthIdToken` en el único uso que ese hook tenía acá: saber
 * cuándo se puede empezar a consultar. El token en sí ya no hace falta
 * guardarlo —lo pide `fetchConToken` en el momento de cada llamada—, y
 * depender de una consulta para averiguar algo que el SDK avisa por su cuenta
 * agregaba un punto de falla: si esa consulta no resolvía, todo lo que
 * colgaba de ella se quedaba esperando para siempre.
 *
 * `undefined` es "todavía restaurando"; `null`, "no hay sesión". La
 * suscripción queda viva, así que un login o un logout dentro de la misma
 * carga de página se reflejan.
 */
export function useSesionDeFirebase() {
  const [uid, setUid] = useState<string | null | undefined>(
    () => auth.currentUser?.uid,
  );

  useEffect(
    () => onAuthStateChanged(auth, (usuario) => setUid(usuario?.uid ?? null)),
    [],
  );

  return {
    restaurando: uid === undefined,
    uid: uid ?? null,
    hayUsuario: !!uid,
  };
}
